import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZapLogoLt = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 120 32",
	fill: "none",
	role: "img",
	"aria-label": "OWASP ZAP",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M16 3 6 18h7l-3 11 12-16h-8l5-10z",
		fill: "#00A29A"
	}), /* @__PURE__ */ _jsx("text", {
		x: 34,
		y: 22,
		fontFamily: "Arial, Helvetica, sans-serif",
		fontSize: 18,
		fontWeight: 700,
		fill: "#1A1A1A",
		children: "ZAP"
	})]
});
export default SvgZapLogoLt;
